export const LOGIN = "/login";
export const PODCASTS = "/podcasts"